import { all } from 'typed-redux-saga'
import { contractsSaga, partnersSaga } from 'Pages/partner'

export function* partnerSaga() {
	yield* all([contractsSaga(), partnersSaga()])
}
